module.exports = __webpack_public_path__ + "img/bg.5a3072dc.png";